// extracted by mini-css-extract-plugin
export default {"card":"Card_card__z8HfQ","overlayContent":"Card_overlayContent__dIuu7"};